import { DialogContent, Dialog, DialogProps, DialogActions } from '@mui/material';
import { useEffect, useMemo } from 'react';
import { __MANAGEMENT_API_URL__ } from 'shell/constants/environment';
import { PmiButton } from 'shell/components/shared/button';
import { Group } from 'shell/models/group';
import { HttpResponse } from 'shell/models/http-response';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import Functionalities from 'system/components/groups/form/table';
import { PmiDialogTitle } from 'shell/components/shared/dialog/title';
import { styled } from '@mui/styles';
import { FunctionalityVM } from 'system/view-models/functionality';
import { headFunctionality } from 'system/components/groups/form/functionality';

export const DialogFunctionality = styled((props: DialogProps) => <Dialog {...props} />)(() => ({
  '& .MuiDialog-paper': {
    minWidth: '500px',
    maxWidth: '800px',
  },
}));

interface ModalFunctionalityProps {
  open: boolean;
  onClose: (open: boolean) => void;
  id?: string;
  checked?: boolean;
}

const ModalFunctionality = ({
  open,
  onClose,
  id,
  checked,
}: ModalFunctionalityProps): React.ReactElement => {
  const {
    data,
    get: getGroup,
    error,
  } = useHttpFetch<HttpResponse<Group>>(`${__MANAGEMENT_API_URL__}/gruppi/${id}`, {
    data: {},
  });

  useEffect(() => {
    getGroup();
  }, []);

  const functionality: Array<FunctionalityVM> = useMemo(() => {
    const group = data?.payload;
    if (!group || !!error) {
      return [];
    }
    return group.funzioni?.map((funzione) => ({
      id: funzione.key.codice.toString(),
      entity: funzione.entita,
      description: funzione.nome,
      checked: checked || false,
    }));
  }, [data]);

  return (
    <DialogFunctionality
      open={open}
      onClose={() => onClose(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <PmiDialogTitle id="alert-dialog-title" backgroundColor="primary" color="white">
        Funzionalità del gruppo
      </PmiDialogTitle>
      <DialogContent style={{ padding: '30px 24px' }}>
        <Functionalities
          head={headFunctionality}
          disabled={true}
          body={functionality || []}
          onCheckPress={() => {
            return;
          }}
          minWidth={700}
        />
      </DialogContent>
      <DialogActions>
        <PmiButton variant="contained" color="primary" type="button" onClick={() => onClose(false)}>
          Chiudi
        </PmiButton>
      </DialogActions>
    </DialogFunctionality>
  );
};

ModalFunctionality.displayName = 'Modal functionalities';

export default ModalFunctionality;
